export default function AboutStory() {
  const highlights = [
    { icon: "ri-layout-grid-line", label: "Residential Layout Development" },
    { icon: "ri-home-2-line", label: "Villa Plot Projects" },
    { icon: "ri-leaf-line", label: "Eco-Friendly Planning" },
    { icon: "ri-shield-check-line", label: "Documentation" },
    { icon: "ri-map-pin-2-line", label: "On Sarjapur Road" },
    { icon: "ri-customer-service-2-line", label: "Transparent Process" },
  ];

  return (
    <section id="story" className="bg-[#FAFAFA] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Left: Image collage */}
          <div className="w-full lg:w-1/2 relative">
            <div className="grid grid-cols-2 gap-3">
              <div className="col-span-2 rounded-2xl overflow-hidden h-56 md:h-72">
                <img
                  src="https://readdy.ai/api/search-image?query=eco%20friendly%20gated%20community%20residential%20layout%20near%20Sarjapur%20Road%20Bangalore%2C%20wide%20roads%20with%20trees%2C%20lush%20green%20residential%20layout%2C%20aerial%20view%2C%20peaceful%20residential%20area%2C%20modern%20gated%20community&width=800&height=450&seq=ui-about-story-01&orientation=landscape"
                  alt="Urban Infra eco-friendly residential layout on Sarjapur Road Bangalore"
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="rounded-xl overflow-hidden h-36 md:h-44">
                <img
                  src="https://readdy.ai/api/search-image?query=wide%20roads%20with%20trees%20in%20residential%20layout%20near%20Bangalore%2C%20gated%20community%20roads%20with%20greenery%2C%20residential%20area%20with%20street%20lights%20and%20trees%2C%20peaceful%20community&width=400&height=300&seq=ui-about-story-02&orientation=landscape"
                  alt="Wide roads in Urban Infra residential layout"
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="rounded-xl overflow-hidden h-36 md:h-44">
                <img
                  src="https://readdy.ai/api/search-image?query=green%20open%20spaces%20in%20residential%20layout%20near%20Sarjapur%20Road%20Bangalore%2C%20park%20area%20in%20gated%20community%2C%20greenery%20in%20residential%20plots%2C%20eco%20friendly%20community&width=400&height=300&seq=ui-about-story-03&orientation=landscape"
                  alt="Green spaces in Urban Infra eco-friendly layout"
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
                />
              </div>
            </div>
            <div className="absolute -bottom-4 -right-4 bg-[#2E7D32] text-white rounded-2xl px-5 py-4 hidden md:block">
              <div className="text-3xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>7+</div>
              <div className="text-green-200 text-xs mt-0.5">Projects Delivered</div>
            </div>
          </div>

          {/* Right: Story content */}
          <div className="w-full lg:w-1/2">
            <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#2E7D32] bg-[#E8F5E9] px-3 py-1.5 rounded-full mb-4">
              Who We Are
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#212121] leading-tight mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>
              A Bengaluru Developer Built on Trust and Eco-Friendly Values
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
              URBAN INFRA is a Bengaluru-based real estate developer focused on creating eco-friendly residential layouts and villa plot communities. Since 2016, the company has delivered projects on Sarjapur Road with strong planning and infrastructure.
            </p>
            <p className="text-gray-600 text-sm leading-relaxed mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
              We focus on quality, transparency, and long-term customer relationships — combining natural living with modern infrastructure and long-term investment value on Sarjapur Road.
            </p>
            <p className="text-gray-600 text-sm leading-relaxed mb-7" style={{ fontFamily: "'Poppins', sans-serif" }}>
              From the first site visit to the final handover, we ensure every step is clear, honest, and aligned with your expectations. That&apos;s the Urban Infra promise.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-8">
              {highlights.map((h) => (
                <div key={h.label} className="flex items-center gap-2 bg-[#E8F5E9] rounded-xl px-3 py-2.5">
                  <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                    <i className={`${h.icon} text-[#7FBF3F] text-base`}></i>
                  </div>
                  <span className="text-xs font-medium text-[#212121]">{h.label}</span>
                </div>
              ))}
            </div>

            <a
              href="/projects"
              className="inline-flex items-center gap-2 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white font-semibold text-sm px-6 py-3 rounded-xl transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-building-4-line"></i>
              View Projects
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
